import { css } from 'linaria';

export const EridWrapper = css`
  display: flex;
  column-gap: var(--space-100);
`;
